import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MemoryCard = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M12.666 16.352H3.333a1.668 1.668 0 0 1-1.667-1.666V5.019c0-.088.035-.173.098-.235L5.43 1.117a.333.333 0 0 1 .236-.097h8.333a.333.333 0 0 1 .333.333v13.333a1.668 1.668 0 0 1-1.666 1.666ZM2.333 5.157v9.529a1 1 0 0 0 1 1h9.333a1 1 0 0 0 1-1v-13H5.804L2.333 5.157Z" />
      <path d="M12 14.353a.333.333 0 0 1-.334-.333v-5H4.333v5a.333.333 0 0 1-.667 0V8.687a.333.333 0 0 1 .333-.333h8a.333.333 0 0 1 .333.333v5.333a.333.333 0 0 1-.333.333ZM7 5.686a.333.333 0 0 1-.334-.333v-2a.333.333 0 1 1 .667 0v2a.333.333 0 0 1-.334.333ZM9.333 5.686A.333.333 0 0 1 9 5.353v-2a.333.333 0 0 1 .667 0v2a.333.333 0 0 1-.334.333ZM11.665 5.686a.333.333 0 0 1-.333-.333v-2a.333.333 0 1 1 .667 0v2a.333.333 0 0 1-.334.333Z" />
    </svg>
  );
};

MemoryCard.category = 'product-category';

MemoryCard.displayName = 'MemoryCard';
